import React from "react";
import { QnA } from "../../../../data/mutualFundSeoPage";
import style from "../mfseo.module.css";

const FAQs = () => (
  <div style={{margin:"16px 0"}}>
    <h2>FAQs</h2>
    {QnA.map(faq => {
      return (
        <>
          <p className={style.question}>{faq.q}</p>
          {faq.ans.map(ans => {
            return <p className={style.greyText}>{ans}</p>;
          })}
        </>
      );
    })}
  </div>
);

export default FAQs;
